import type { DealCard } from './types'

/**
 * การ์ด DEAL — หัวใจของกลไก Cashflow
 * ซื้อสินทรัพย์ที่ปั๊ม "กระแสเงินสดต่อเดือน" เข้ามาโดยไม่ต้องรอให้ใครเหยียบช่อง
 * dealเล็ก = ราคาย่อมเยา ปั้นทีละนิด | dealใหญ่ = ดาวน์หนัก แต่ดันให้หลุดวงจรหนูได้เร็ว
 */
export const DEAL_CARDS: DealCard[] = [
  /* ---------- DEAL เล็ก ---------- */
  {
    id: 'd-nanocorp',
    size: 'small',
    kind: 'stock',
    name: 'หุ้น NanoCorp',
    emoji: '📈',
    text: 'บริษัทนาโนบอททำความสะอาดท่อระบายน้ำเมือง จ่ายปันผลนิ่ง ๆ ทุกเดือน',
    price: 24_000,
    cashflow: 400,
    value: 30_000,
    units: 200,
  },
  {
    id: 'd-solarpanel',
    size: 'small',
    kind: 'business',
    name: 'แผงโซลาร์บนดาดฟ้า',
    emoji: '🔆',
    text: 'ติดแผงโซลาร์แล้วขายไฟเข้ากริดเมือง เงินเข้าทุกเดือนแบบไม่ต้องทำอะไร',
    price: 40_000,
    cashflow: 900,
    value: 46_000,
  },
  {
    id: 'd-studio',
    size: 'small',
    kind: 'realestate',
    name: 'ห้องสตูดิโอปล่อยเช่า',
    emoji: '🛏️',
    text: 'สตูดิโอ 22 ตร.ม. ใกล้สถานีไฮเปอร์ลูป ผ่อนธนาคาร แต่ค่าเช่าคลุมได้',
    price: 320_000,
    down: 48_000,
    cashflow: 1_400,
    value: 380_000,
  },
  {
    id: 'd-vendingbot',
    size: 'small',
    kind: 'business',
    name: 'ตู้กดขนมหุ่นยนต์ 3 ตู้',
    emoji: '🍫',
    text: 'ตู้เดินได้เอง ไปจอดตรงไหนคนก็ซื้อ เติมของอาทิตย์ละครั้ง',
    price: 36_000,
    cashflow: 850,
    value: 40_000,
  },
  {
    id: 'd-dogewalk',
    size: 'small',
    kind: 'business',
    name: 'บริการโดรนพาหมาเดิน',
    emoji: '🐕',
    text: 'สตาร์ทอัพเล็ก ๆ ที่คนรักสัตว์ยอมจ่ายแพง กำไรดีเกินคาด',
    price: 28_000,
    cashflow: 750,
    value: 31_000,
  },
  {
    id: 'd-moondust',
    size: 'small',
    kind: 'crypto',
    name: 'เหรียญ MOONDUST',
    emoji: '🌕',
    text: 'เหรียญมีมจากเหมืองดวงจันทร์ ผันผวนโหด ไม่มีปันผล แต่ถ้าขึ้นคือขึ้น',
    price: 20_000,
    cashflow: 0,
    value: 20_000,
    units: 2_000,
  },
  {
    id: 'd-arcade',
    size: 'small',
    kind: 'business',
    name: 'ตู้เกม VR ในห้าง',
    emoji: '🕹️',
    text: 'เด็กต่อคิวยาว รายได้เข้าทุกวัน หัก % ให้ห้างแล้วยังเหลือ',
    price: 52_000,
    cashflow: 1_200,
    value: 58_000,
  },
  {
    id: 'd-carwash',
    size: 'small',
    kind: 'business',
    name: 'คาร์แคร์อัตโนมัติ',
    emoji: '🧼',
    text: 'ล้างรถไร้คนขับ ทำงาน 24 ชม. ไม่ลาป่วย ไม่ขอขึ้นเงินเดือน',
    price: 64_000,
    cashflow: 1_500,
    value: 72_000,
  },
  {
    id: 'd-bond',
    size: 'small',
    kind: 'stock',
    name: 'พันธบัตรสถานีอวกาศ',
    emoji: '🎫',
    text: 'ปลอดภัยที่สุดในกระดาน ผลตอบแทนไม่หวือหวาแต่ไม่มีวันเป็นศูนย์',
    price: 50_000,
    cashflow: 550,
    value: 52_000,
  },
  {
    id: 'd-foodtruck',
    size: 'small',
    kind: 'business',
    name: 'ฟู้ดทรัคบินได้',
    emoji: '🌮',
    text: 'ทาโก้ลอยฟ้า ขายตามงานอีเวนต์ กำไรต่อคำสูงมาก',
    price: 58_000,
    cashflow: 1_350,
    value: 62_000,
  },
  {
    id: 'd-townhouse',
    size: 'small',
    kind: 'realestate',
    name: 'ทาวน์เฮาส์เก่าปรับปรุงใหม่',
    emoji: '🏘️',
    text: 'ซื้อถูกเพราะเจ้าของย้ายไปดาวอังคาร รีโนเวทแล้วปล่อยเช่าได้ดี',
    price: 420_000,
    down: 63_000,
    cashflow: 1_900,
    value: 510_000,
  },
  {
    id: 'd-podcast',
    size: 'small',
    kind: 'business',
    name: 'พอดแคสต์การเงิน',
    emoji: '🎙️',
    text: 'อัดสัปดาห์ละตอน สปอนเซอร์จ่ายรายเดือน สินทรัพย์ที่ทำครั้งเดียวได้ยาว',
    price: 18_000,
    cashflow: 600,
    value: 20_000,
  },
  {
    id: 'd-etf',
    size: 'small',
    kind: 'stock',
    name: 'กองทุน ETF หุ่นยนต์โลก',
    emoji: '🌐',
    text: 'กระจายความเสี่ยงทั่วโลกในใบเดียว ปันผลสม่ำเสมอ',
    price: 45_000,
    cashflow: 700,
    value: 54_000,
    units: 300,
  },
  {
    id: 'd-laundry',
    size: 'small',
    kind: 'business',
    name: 'ร้านสะดวกซักควอนตัม',
    emoji: '🧺',
    text: 'ซักเสร็จใน 90 วินาที คนแน่นตลอด ค่าเช่าที่ถูกเพราะอยู่ใต้ดิน',
    price: 72_000,
    cashflow: 1_800,
    value: 80_000,
  },
  {
    id: 'd-parking',
    size: 'small',
    kind: 'realestate',
    name: 'ที่จอดยานลอย 6 ช่อง',
    emoji: '🅿️',
    text: 'ไม่มีอะไรต้องซ่อม ไม่มีผู้เช่าโทรมากลางคืน สินทรัพย์ในฝันของคนขี้เกียจ',
    price: 96_000,
    cashflow: 1_600,
    value: 108_000,
  },

  /* ---------- DEAL ใหญ่ ---------- */
  {
    id: 'd-apartment',
    size: 'big',
    kind: 'realestate',
    name: 'อพาร์ตเมนต์ 24 ยูนิต',
    emoji: '🏢',
    text: 'ตึกเก่าใกล้นิคมหุ่นยนต์ ผู้เช่าเต็ม 100% เจ้าของอยากขายด่วน',
    price: 2_400_000,
    down: 290_000,
    cashflow: 9_500,
    value: 2_900_000,
  },
  {
    id: 'd-warehouse',
    size: 'big',
    kind: 'realestate',
    name: 'คลังสินค้าโดรน',
    emoji: '📦',
    text: 'ยักษ์ใหญ่อีคอมเมิร์ซเซ็นสัญญาเช่า 10 ปี รายได้มั่นคงสุด ๆ',
    price: 1_800_000,
    down: 240_000,
    cashflow: 8_200,
    value: 2_200_000,
  },
  {
    id: 'd-datacenter',
    size: 'big',
    kind: 'business',
    name: 'ดาต้าเซ็นเตอร์ใต้ทะเล',
    emoji: '🌊',
    text: 'ระบายความร้อนด้วยน้ำทะเล ต้นทุนต่ำมาก ลูกค้า AI แย่งกันเช่า',
    price: 900_000,
    down: 320_000,
    cashflow: 12_000,
    value: 1_400_000,
  },
  {
    id: 'd-franchise',
    size: 'big',
    kind: 'business',
    name: 'แฟรนไชส์ร้านชาไข่มุกหุ่นยนต์ 5 สาขา',
    emoji: '🧋',
    text: 'ระบบพร้อม ทีมพร้อม เราแค่เป็นเจ้าของ — นี่แหละสินทรัพย์',
    price: 1_100_000,
    down: 260_000,
    cashflow: 10_500,
    value: 1_500_000,
  },
  {
    id: 'd-mine',
    size: 'big',
    kind: 'crypto',
    name: 'ฟาร์มขุดคริปโตพลังฟิวชัน',
    emoji: '⛏️',
    text: 'ไฟฟรีจากโรงฟิวชัน กำไรมหาศาลตอนตลาดขึ้น แต่ตลาดลงก็เจ็บ',
    price: 700_000,
    down: 220_000,
    cashflow: 9_000,
    value: 900_000,
  },
  {
    id: 'd-hotel',
    size: 'big',
    kind: 'realestate',
    name: 'โฮสเทลแคปซูลลอยฟ้า',
    emoji: '🛎️',
    text: 'นักท่องเที่ยวอวกาศต้องพักที่ไหนสักที่ อัตราเข้าพักสูงทั้งปี',
    price: 2_000_000,
    down: 300_000,
    cashflow: 11_000,
    value: 2_600_000,
  },
  {
    id: 'd-farmland',
    size: 'big',
    kind: 'realestate',
    name: 'ที่ดินฟาร์มสาหร่ายโปรตีน',
    emoji: '🌾',
    text: 'อาหารโลกอนาคต ปล่อยให้บริษัทเช่าทำกินระยะยาว',
    price: 1_300_000,
    down: 200_000,
    cashflow: 7_000,
    value: 1_700_000,
  },
  {
    id: 'd-satellite',
    size: 'big',
    kind: 'exotic',
    name: 'ดาวเทียมอินเทอร์เน็ต 3 ดวง',
    emoji: '📡',
    text: 'ให้เช่าแบนด์วิดท์แก่หมู่บ้านนอกโดม ค่าเช่าเข้าตรงเวลาทุกเดือน',
    price: 1_600_000,
    down: 350_000,
    cashflow: 13_500,
    value: 2_100_000,
  },
  {
    id: 'd-clinic',
    size: 'big',
    kind: 'business',
    name: 'เครือคลินิกยืดอายุขัย',
    emoji: '💊',
    text: 'คนรวยจ่ายไม่อั้นเพื่อชีวิตที่ยาวขึ้น มาร์จิ้นสูงจนน่ากลัว',
    price: 1_450_000,
    down: 380_000,
    cashflow: 15_000,
    value: 1_900_000,
  },
  {
    id: 'd-spaceport',
    size: 'big',
    kind: 'exotic',
    name: 'หุ้นส่วนท่าอวกาศเอกชน',
    emoji: '🛫',
    text: 'ดีลใหญ่ที่สุดในกระดาน ถ้าปิดได้คือเปลี่ยนเกมทั้งกระดาน',
    price: 3_200_000,
    down: 520_000,
    cashflow: 19_000,
    value: 4_200_000,
  },
  {
    id: 'd-studioblock',
    size: 'big',
    kind: 'realestate',
    name: 'ตึกสตูดิโอ 12 ยูนิต',
    emoji: '🏬',
    text: 'ใกล้เขตเรียนรู้ นักศึกษาเต็มตึกทุกเทอม',
    price: 1_150_000,
    down: 175_000,
    cashflow: 6_400,
    value: 1_450_000,
  },
  {
    id: 'd-robolease',
    size: 'big',
    kind: 'business',
    name: 'ธุรกิจให้เช่าหุ่นยนต์ก่อสร้าง',
    emoji: '🏗️',
    text: 'ซื้อหุ่นครั้งเดียว ปล่อยเช่าได้สิบปี — เลเวอเรจของจริง',
    price: 980_000,
    down: 230_000,
    cashflow: 9_800,
    value: 1_250_000,
  },
  {
    id: 'd-cinema',
    size: 'big',
    kind: 'business',
    name: 'โรงหนังโฮโลกราฟิก',
    emoji: '🍿',
    text: 'ป๊อปคอร์นกำไร 900% ตั๋วแค่ของแถม',
    price: 1_250_000,
    down: 270_000,
    cashflow: 8_800,
    value: 1_550_000,
  },
]

export const DEAL_BY_ID = new Map(DEAL_CARDS.map((c) => [c.id, c]))
